import styled, { css } from "styled-components";
export var TabGroupUl = /*#__PURE__*/ styled.ul.withConfig({
  displayName: "TabGroupstyle__TabGroupUl"
})(() =>
  css([
    "display:flex;margin:0;padding:0;overflow-x:auto;&::-webkit-scrollbar{display:none;}-ms-overflow-style:none;scrollbar-width:none;"
  ])
);
export var TabPanel = /*#__PURE__*/ styled.section.withConfig({
  displayName: "TabGroupstyle__TabPanel"
})([""]);
